import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2090. ダッシュボード（チーム別合計金額）
 * [GET] /workspaces/:identifier/dashboard/amount_by_team
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type DashboardAmountByTeam = {
  names: string[];
  amounts: number[];
};

const dashboardAmountByTeam = (props: Props): Promise<DashboardAmountByTeam> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/amount_by_team`, { params: props });
};

export const useDashboardAmountByTeam = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'amount_by_team', { ...props }],
    queryFn: () => dashboardAmountByTeam(props),
    staleTime: 1000 * 60 * 30,
  });
};
